/** Phase 6 — members & contributors view styling tokens. */

export const memberCard =
  'bg-dark-surface border border-dark-border rounded-xl p-4 hover:border-dark-border-glow transition-all duration-200';

export const memberAvatarBorder = 'border-2 border-dark-border';

export const memberNameClass = 'text-slate-100 font-semibold text-sm';
export const memberRoleClass = 'text-slate-400 text-xs mt-0.5';

export const memberStatsRowClass = 'flex gap-4 mt-3 pt-3 border-t border-dark-border';
export const memberStatValueClass = 'text-slate-100 font-semibold text-sm';
export const memberStatLabelClass = 'text-slate-500 text-xs';

export const profileHeaderClass =
  'mb-6 rounded-xl border border-dark-border bg-dark-surface px-6 py-6';
export const profileNameClass = 'text-2xl font-bold text-slate-100';
export const profileContactClass = 'text-slate-400 text-sm flex items-center gap-2';

export const leaderboardRowClass =
  'flex items-center gap-3 px-4 py-3 border-b border-dark-border hover:bg-dark-elevated/50 transition-colors';

export const contributorProgressTrack =
  'h-1.5 flex-1 min-w-0 overflow-hidden rounded-full bg-dark-border';
export const contributorProgressFill =
  'h-full rounded-full bg-gradient-to-r from-brand-purple to-brand-teal transition-[width] duration-300 ease-out';

/** Rank colours: 1st gold, 2nd silver, 3rd bronze, rest muted. */
export function leaderboardRankClass(rank) {
  if (rank === 1) return 'text-amber-400';
  if (rank === 2) return 'text-slate-300';
  if (rank === 3) return 'text-amber-600';
  return 'text-slate-500';
}

export const teamSectionHeaderClass =
  'flex items-center justify-between gap-2 border-b border-dark-border bg-dark-elevated px-4 py-3';

export const teamSectionTitleClass = 'text-sm font-semibold text-slate-200';

export const teamMemberRowClass =
  'flex items-center justify-between gap-2 border-b border-dark-border px-4 py-3 transition-colors hover:bg-dark-elevated/50 last:border-b-0';
